import {Button, Stack} from "@mui/material";
import {menuItems} from "../../routing/MenuItems";
import {Link as RouterLink, useLocation} from "react-router";
import React from "react";

export const DesktopMenu = () => {
    const currentPagePath = useLocation().pathname;

    return (
        <Stack direction="row" width="100%" alignItems="flex-end" justifyContent="center" spacing={1}>
            {menuItems.map((item) => (
                <Button
                    key={item.label}
                    component={RouterLink}
                    to={item.path}
                    variant="navButton"
                    className={(currentPagePath === item.path) ? "active" : ""}
                >
                    {item.label}
                </Button>
            ))}
        </Stack>
    );
};